// extracted by mini-css-extract-plugin
export default {"footerCopyrightNotice":"FooterNav_footerCopyrightNotice__63DXa","footerNav":"FooterNav_footerNav__ohJMH","footerNavLink":"FooterNav_footerNavLink__Jy+o6"};